import { cn } from '@repo/lib/cn';
import { CheckIcon, XIcon } from 'lucide-react';

export interface QuestionCorrectProps {
  correctState?: boolean;
  incorrectState?: boolean;
}

export function questionCorrect(correct?: boolean) {
  const getStateClassNames = (getStateClassNamesProps?: QuestionCorrectProps) => {
    const { correctState, incorrectState } = getStateClassNamesProps || {};
    if (correct === true) {
      return cn('border-fill-success bg-fill-success/15', correctState);
    }
    if (correct === false) {
      return cn('border-fill-destructive bg-fill-destructive/10', incorrectState);
    }
    return 'bg-surface-primary hover:bg-surface-primary-hover border border-border-primary has-data-[state=checked]:border-border-brand has-data-[state=checked]:bg-surface-brand has-data-[state=checked]:hover:bg-surface-brand-hover';
  };

  const getIcon = (getIconProps?: QuestionCorrectProps) => {
    const { correctState, incorrectState } = getIconProps || {};
    if (correct === true) {
      return <CheckIcon className={cn('stroke-icon-success absolute top-1/2 right-3 size-4 -translate-y-1/2', correctState)} />;
    }
    if (correct === false) {
      return <XIcon className={cn('stroke-icon-destructive absolute top-1/2 right-3 size-4 -translate-y-1/2', incorrectState)} />;
    }
    return null;
  };

  return {
    getStateClassNames,
    getIcon,
  };
}
